// React
import React, { useState } from "react";

// Reactstrap
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Card,
  CardBody,
  Collapse,
} from "reactstrap";

// Componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ImportSchedule from "./ImportSchedule";
import ImportScheduleQuotas from "./ImportScheduleQuotas";
import ImportScheduleUpdate from "./ImportScheduleUpdate";
import ImportScheduleDelete from "./ImporScheduleDelete";

const sectionRowStyle = (width) => ({
  display: "flex",
  flexDirection: "row",
  marginBottom: 10,
  width,
});

export default function ModalImportQuotasWrapper(props) {
  const { isOpen, toggle, idEvent, token, checkProductExists } = props;

  // state de collapse
  const [activeSection, setActiveSection] = useState(null);

  // Fecha todos os collapses e o modal
  function toggleBackdrop() {
    setActiveSection(null);
    toggle();
  }

  // Abre a seção clicada e fecha as demais
  function toggleSection(section) {
    setActiveSection((prev) => (prev === section ? null : section));
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleBackdrop} autoFocus centered>
      <ModalHeader toggle={toggleBackdrop}>Importação Agenda</ModalHeader>
      <ModalBody className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            {(checkProductExists("APP Eventos Plus") ||
              checkProductExists("RSVP")) && (
              <>
                <div>
                  <Row style={sectionRowStyle("245px")}>
                    <SectionComponent
                      sectionName="Criar Agendas"
                      setIsOpen={() => toggleSection("create")}
                      isOpen={activeSection === "create"}
                    />
                  </Row>
                  <Collapse isOpen={activeSection === "create"}>
                    <ImportSchedule
                      isOpen={isOpen}
                      toggle={toggleBackdrop}
                      token={token}
                      idEvent={idEvent}
                    />
                  </Collapse>
                </div>
                <div>
                  <Row style={sectionRowStyle("245px")}>
                    <SectionComponent
                      sectionName="Atualizar Agendas"
                      setIsOpen={() => toggleSection("update")}
                      isOpen={activeSection === "update"}
                    />
                  </Row>
                  <Collapse isOpen={activeSection === "update"}>
                    <ImportScheduleUpdate
                      isOpen={isOpen}
                      toggle={toggleBackdrop}
                      token={token}
                      idEvent={idEvent}
                    />
                  </Collapse>
                </div>
                <div>
                  <Row style={sectionRowStyle("245px")}>
                    <SectionComponent
                      sectionName="Deletar Agendas"
                      setIsOpen={() => toggleSection("delete")}
                      isOpen={activeSection === "delete"}
                    />
                  </Row>
                  <Collapse isOpen={activeSection === "delete"}>
                    <ImportScheduleDelete
                      isOpen={isOpen}
                      toggle={toggleBackdrop}
                      token={token}
                      idEvent={idEvent}
                    />
                  </Collapse>
                </div>
              </>
            )}
            {checkProductExists("Distribuição de Cotas") && (
              <div>
                <Row style={sectionRowStyle("280px")}>
                  <SectionComponent
                    sectionName="Criar Agendas Cotas"
                    setIsOpen={() => toggleSection("quotas")}
                    isOpen={activeSection === "quotas"}
                  />
                </Row>
                <Collapse isOpen={activeSection === "quotas"}>
                  <ImportScheduleQuotas
                    isOpen={isOpen}
                    toggle={toggleBackdrop}
                    token={token}
                    idEvent={idEvent}
                  />
                </Collapse>
              </div>
            )}
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}
